// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__10q2x","label":"Radio_label__35xaU","checkMark":"Radio_checkMark__1x1ot","disabled":"Radio_disabled__2jYG8"};